import { IAfterGuiAttachedParams } from '@ag-grid-enterprise/all-modules';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { GastroPayService } from '@app/gastro-pay/gastro-pay.service';
import { MenucardsService } from '@app/menucards/menucards.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'ng-select-renderer',
  template: `
    <ng-select
      [items]="items"
      [multiple]="false"
      bindLabel="name"
      placeholder="Stadtteil auswählen..."
      [closeOnSelect]="true"
      [(ngModel)]="selectedItem"
      appendTo="body"
      [clearable]="true"
      [disabled]="isDisabled"
      #select
    >
    </ng-select>
  `
})
export class NgSelectDistrictRendererComponent implements ICellRendererAngularComp, OnDestroy {
  params: any;
  isDisabled: boolean;
  items: any[] = [];
  selectedItem: any = [];
  @ViewChild(NgSelectComponent, { static: false }) select: NgSelectComponent;

  constructor(private gastropayService: GastroPayService) {}

  ngOnDestroy(): void {}
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    console.log(this.select);
    setTimeout(() => {
      this.select.open();
    });
  }

  agInit(params: any): void {
    this.params = params;
    this.selectedItem = this.params.data.districtId || null;
    if (!this.params.data.locationId) {
      this.isDisabled = true;
    }
    this.getItems();
  }

  getItems() {
    this.gastropayService.getLocationDisctricts(this.params.data.locationId).subscribe(locations => {
      console.log(70, locations);
      this.items = locations;
    });
  }

  getValue(): any {
    return this.selectedItem;
  }
}
